import type { TemplateConfig } from "../config/configType";
import { getResolvedTemplateConfig } from "../config/resolvedTemplateConfig";
import SectionWrapper from "@/components/layouts/SectionWrapper";
import HeaderSection from "@/components/organisms/entry-page/header-section";
import FeaturesSection from "@/components/organisms/entry-page/features-section";
import HowItWorksSection from "@/components/organisms/entry-page/how-it-works-section";
import PricingSection from "@/components/organisms/entry-page/pricing-section";
import TestimonialsSection from "@/components/organisms/entry-page/testimonials-section";
import FaqSection from "@/components/organisms/entry-page/faq-section";
import AppBannerSection from "@/components/organisms/entry-page/app-banner-section";
import ScrollToTop from "@/components/molecules/ScrollToTop";

const config: TemplateConfig = getResolvedTemplateConfig();

const EntryInApp = () => {
  return (
    <div
      data-theme="previn"
      className="min-h-screen bg-base-100 font-rowdies text-base-content"
    >
      <div className="pt-24 laptop:pt-28">
        <main>
        {/* Section 1: Header/Hero */}
        <SectionWrapper 
          id="hero"
          className="bg-base-100 overflow-visible"
          innerClassName="py-4 md:py-16"
        >
          <HeaderSection />
        </SectionWrapper>

        {/* Section 3: Features */}
        <SectionWrapper 
          id={config.home?.features?.id || "features"}
          className="bg-base-100"
          innerClassName="py-12"
        >
          <FeaturesSection />
        </SectionWrapper>

        {/* Section 4: How It Works */}
        <SectionWrapper 
          id={config.home?.howItWorks?.id || "how-it-works"}
          className="bg-base-100"
          innerClassName="py-12"
        >
          <HowItWorksSection />
        </SectionWrapper>

        {/* Section 5: Pricing */}
        <SectionWrapper 
          id={config.home?.pricing?.id || "pricing"}
          className="bg-base-100"
          innerClassName="py-12"
        >
          <PricingSection />
        </SectionWrapper>

        {/* Section 6: Testimonials */}
        <SectionWrapper 
          id={config.home?.testimonials?.id || "testimonials"}
          className="bg-base-100"
          innerClassName="py-12"
        >
          <TestimonialsSection />
        </SectionWrapper>

        {/* Section 7: FAQ */}
        <SectionWrapper 
          id={config.home?.faq?.id || "faq"}
          className="bg-base-100"
          innerClassName="py-12"
        >
          <FaqSection />
        </SectionWrapper>

        {/* Section 8: App Banner */}
        <SectionWrapper 
          id={config.appBanner?.id || "app-banner"}
          className="bg-base-100"
          innerClassName="py-12"
        >
          <AppBannerSection />
        </SectionWrapper>
      </main>
      </div>
      <ScrollToTop />
    </div>
  );
};

export default EntryInApp;
